export enum KruxEvent {
    FIRE_PAGE_VIEW = 'kruxFirePageView'
}
